import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { BeneficiosTributariosDescuentosModalComponent } from '../../beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { IngresosComercianteModalComponent } from '../ingresos-comerciante/ingresos-comerciante-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['534'] }
];

const tableStructure = [
  { id: 'informante', title: 'Informante' },
  { id: 'origen', title: 'Origen de la información' },
  { id: 'nombreTipoActivo', title: 'Tipo de Activo' },
  { id: 'ValorVenta', title: 'Valor Venta' },
  { id: 'CostoFiscal', title: 'Costo Declarado' }
];


class Form1 {

  id: number;
  idSugerida: number;
  informante: string;
  Ubicacion: string;
  TipodeActivo: string;
  nombreTipoActivo: string;
  Aniodecompra: string;
  ValordeCompra: string;
  AnioAnteriorAplicoReajusteArt73ET: string;
  ValorDeclaradoAnioAnterior: string;
  ValorVenta: string;
  Mejoras: string;
  origen: string;
  AvaluoCatastralAnioAnterior: string;
  CostoFiscal: string;
  RetencionDivididoImpuestoExterior: string;
  utilidad: string;
  ResultadoArt73Masmejoras: string;
  AvaluoCatastralMasMejoras: string;
  ValorDeclaradoAnioAnteriorMasMejoras: string;
  ValorDeCompraMasMejoras: string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-venta-activos-fijos-modal',
  templateUrl: './ingresos-venta-activos-fijos-modal.component.html',
  styleUrls: ['./ingresos-venta-activos-fijos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosVentaActivosFijosModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstSiNo: ArticulosDominio[] = [];
  public lstCostoFiscal: ArticulosDominio[] = [];
  public lstArticulos: ArticulosDominio[] = [];
  public lstTipoActivos: ArticulosDominio[] = [];
  public listaUbicacion: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;
  listaModoAdquisicion: any;
  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    public dialogRef: MatDialogRef<IngresosVentaActivosFijosModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    // this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {

  }


  protected inicializeForm() {

    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;
    this.modelForm.informante = '';
    this.modelForm.Ubicacion = '1';
    this.modelForm.TipodeActivo = '0';
    this.modelForm.nombreTipoActivo = 'Inmuebles'
    this.modelForm.Aniodecompra = '';
    this.modelForm.ValordeCompra = '0';
    this.modelForm.AnioAnteriorAplicoReajusteArt73ET = '0';
    this.modelForm.ValorDeclaradoAnioAnterior = '0';
    this.modelForm.ValorVenta = '0';
    this.modelForm.Mejoras = '0';
    this.modelForm.origen = '';
    this.modelForm.AvaluoCatastralAnioAnterior = '0';
    this.modelForm.CostoFiscal = '0';
    this.modelForm.RetencionDivididoImpuestoExterior = '0';
    this.modelForm.utilidad = '0';
    this.modelForm.ResultadoArt73Masmejoras = '0';
    this.modelForm.AvaluoCatastralMasMejoras = '0';
    this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras = '0';
    this.modelForm.ValorDeCompraMasMejoras = '0';


    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_535 == undefined) {

      this.model.doc.cuerpo.cc_id_546 = [];//Ubicación
      this.model.doc.cuerpo.cc_id_535 = []; //informante
      this.model.doc.cuerpo.cc_id_537 = [];//tipo de activo
      this.model.doc.cuerpo.cc_id_536 = []; //origen
      this.model.doc.cuerpo.cc_id_547 = []; //año de compra
      this.model.doc.cuerpo.cc_id_548 = []; //valor de compra
      this.model.doc.cuerpo.cc_id_549 = [];//AnioAnteriorAplicoReajusteArt73ET
      this.model.doc.cuerpo.cc_id_550 = [];//ValorDeclaradoAnioAnterior
      this.model.doc.cuerpo.cc_id_538 = []; //Valor de venta
      this.model.doc.cuerpo.cc_id_551 = [];//mejoras
      this.model.doc.cuerpo.cc_id_552 = []; //AvaluoCatastralAnioAnterior
      this.model.doc.cuerpo.cc_id_553 = [];//costo fiscal
      this.model.doc.cuerpo.cc_id_554 = [];//RetencionDivididoImpuestoExterior
      this.model.doc.cuerpo.cc_id_555 = [];//utilidad
      this.model.doc.cuerpo.cc_id_556 = [];//ResultadoArt73Masmejoras
      this.model.doc.cuerpo.cc_id_557 = [];//AvaluoCatastralMasMejoras
      this.model.doc.cuerpo.cc_id_558 = [];//ValorDeclaradoAnioAnteriorMasMejoras
      this.model.doc.cuerpo.cc_id_559 = [];//ValorDeCompraMasMejoras

    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649



    if (this.modelForm.TipodeActivo == '4') {
      this.modelForm.AnioAnteriorAplicoReajusteArt73ET = '0'
    }
    this.lstSiNo[0] = { valor: 0, nombre: "No" };
    this.lstSiNo[1] = { valor: 1, nombre: "Sí" };

    this.lstCostoFiscal = [];

    switch (this.modelForm.AnioAnteriorAplicoReajusteArt73ET) {
      case '0':
        if (this.modelForm.TipodeActivo != '4') {
          if (this.modelForm.AvaluoCatastralAnioAnterior != '0') {
            this.lstCostoFiscal[0] = { valor: Number(this.modelForm.AvaluoCatastralMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Avaluó catastral + mejora: " + this.modelForm.AvaluoCatastralMasMejoras : "Avaluó catastral: " + this.modelForm.AvaluoCatastralMasMejoras };
            this.lstCostoFiscal[1] = { valor: Number(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor declarado año anterior + mejora: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras : "Valor declarado año anterior: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras };
            this.lstCostoFiscal[2] = { valor: Number(this.modelForm.ValorDeCompraMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor de compra + mejora: " + this.modelForm.ValorDeCompraMasMejoras : "Valor de compra: " + this.modelForm.ValorDeCompraMasMejoras };
          } else {
            this.lstCostoFiscal[0] = { valor: Number(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor declarado año anterior + mejora: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras : "Valor declarado año anterior: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras };
            this.lstCostoFiscal[1] = { valor: Number(this.modelForm.ValorDeCompraMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor de compra + mejora: " + this.modelForm.ValorDeCompraMasMejoras : "Valor de compra: " + this.modelForm.ValorDeCompraMasMejoras };
          }

        } else {
          this.lstCostoFiscal[0] = { valor: Number(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor declarado año anterior + mejora: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras : "Valor declarado año anterior: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras };
          this.lstCostoFiscal[1] = { valor: Number(this.modelForm.ValorDeCompraMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor de compra + mejora: " + this.modelForm.ValorDeCompraMasMejoras : "Valor de compra: " + this.modelForm.ValorDeCompraMasMejoras };
        }
        break;

      case '1':
        if (this.modelForm.TipodeActivo == '1') {
          this.lstCostoFiscal[0] = { valor: Number(this.modelForm.ResultadoArt73Masmejoras), nombre: this.modelForm.Mejoras != '0' ? "Resultado Art 73 + mejora: " + this.modelForm.ResultadoArt73Masmejoras : "Resultado Art 73: " + this.modelForm.ResultadoArt73Masmejoras };
          this.lstCostoFiscal[1] = { valor: Number(this.modelForm.AvaluoCatastralMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Avaluó catastral + mejora: " + this.modelForm.AvaluoCatastralMasMejoras : "Avaluó catastral: " + this.modelForm.AvaluoCatastralMasMejoras };
          this.lstCostoFiscal[2] = { valor: Number(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor declarado año anterior + mejora: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras : "Valor declarado año anterior: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras };
          this.lstCostoFiscal[3] = { valor: Number(this.modelForm.ValorDeCompraMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor de compra + mejora: " + this.modelForm.ValorDeCompraMasMejoras : "Valor de compra: " + this.modelForm.ValorDeCompraMasMejoras };
        } else {
          this.lstCostoFiscal[0] = { valor: Number(this.modelForm.ResultadoArt73Masmejoras), nombre: this.modelForm.Mejoras != '0' ? "Resultado Art 73 + mejora: " + this.modelForm.ResultadoArt73Masmejoras : "Resultado Art 73: " + this.modelForm.ResultadoArt73Masmejoras };
          this.lstCostoFiscal[1] = { valor: Number(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor declarado año anterior + mejora: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras : "Valor declarado año anterior: " + this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras };
          this.lstCostoFiscal[2] = { valor: Number(this.modelForm.ValorDeCompraMasMejoras), nombre: this.modelForm.Mejoras != '0' ? "Valor de compra + mejora: " + this.modelForm.ValorDeCompraMasMejoras : "Valor de compra: " + this.modelForm.ValorDeCompraMasMejoras };

        }


        break;
      default:
        break;
    }


    this.lstTipoActivos = [];
    if (this.modelForm.Ubicacion == '1') {
      this.lstTipoActivos[0] = { valor: 1, nombre: "Inmuebles" };
      this.lstTipoActivos[1] = { valor: 2, nombre: "Acciones o aportes" };
      this.lstTipoActivos[2] = { valor: 3, nombre: "Acciones en bolsa Colombia" };
      this.lstTipoActivos[3] = { valor: 4, nombre: "Otros" };
    }
    if (this.modelForm.Ubicacion == '2') {//ubicación en el exteriior
      if (this.modelForm.TipodeActivo == '3') {//anula la opción acciones en la bolsa de Colombia
        this.modelForm.TipodeActivo = '';
      }
      this.lstTipoActivos[0] = { valor: 1, nombre: "Inmuebles" };
      this.lstTipoActivos[1] = { valor: 2, nombre: "Acciones o aportes" };
      this.lstTipoActivos[2] = { valor: 4, nombre: "Otros" };
    }


    this.listaUbicacion[0] = { valor: 1, nombre: "Nacional" };
    this.listaUbicacion[1] = { valor: 2, nombre: "Exterior" };

    this.lstArticulos[0] = { valor: 0, nombre: "" };
    this.lstArticulos[1] = { valor: 1, nombre: "Avaluó catastral o auto avaluó anterior" };
    this.lstArticulos[2] = { valor: 2, nombre: "Valor de compra" };
    this.lstArticulos[3] = { valor: 3, nombre: "Valor declarado año anterior" };
    this.lstArticulos[4] = { valor: 4, nombre: "Reajustado Art. 70" };
    this.lstArticulos[5] = { valor: 5, nombre: "Reajustado Art. 73" };

  }

  protected initializeAnios() {
    /*  for(let i=0; i<this.tablaArt73.length;i++){ 
     this.lstAnios[i]=Number(this.tablaArt73[i].anio);*/
    this.lstAnios = this.tablaArt73
      .filter(item => item.anioGravable === "2023")
      .map(item => item.anio);
    // }
  }

  public operacionCs539() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      //if(this.dataSourceBody[i].origen == "2")
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].ValorVenta, suma);
      /*   else
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valCatastral, suma); */
    }
    if (suma)
      this.model.doc.cuerpo.cs_id_539 = suma;
    else
      this.model.doc.cuerpo.cs_id_539 = '0';
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_535.length; i++) {
      this.modelForm.id = i;
      this.modelForm.informante = this.model.doc.cuerpo.cc_id_535[i].v;
      this.modelForm.Ubicacion = this.model.doc.cuerpo.cc_id_546[i].v;
      this.modelForm.TipodeActivo = this.model.doc.cuerpo.cc_id_537[i].v;
      // this.modelForm.nombreTipoActivo = this.lstTipoActivos[Number(this.model.doc.cuerpo.cc_id_537[i].v) - 1].nombre;
      this.modelForm.nombreTipoActivo = this.lstTipoActivos.find(elemento => elemento.valor.toString() == this.modelForm.TipodeActivo).nombre;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_536[i].v;
      this.modelForm.Aniodecompra = this.model.doc.cuerpo.cc_id_547[i].v;
      this.modelForm.ValordeCompra = this.model.doc.cuerpo.cc_id_548[i].v;
      this.modelForm.AnioAnteriorAplicoReajusteArt73ET = this.model.doc.cuerpo.cc_id_549[i].v;
      this.modelForm.ValorDeclaradoAnioAnterior = this.model.doc.cuerpo.cc_id_550[i].v;
      this.modelForm.ValorVenta = this.model.doc.cuerpo.cc_id_538[i].v;
      this.modelForm.Mejoras = this.model.doc.cuerpo.cc_id_551[i].v;
      this.modelForm.AvaluoCatastralAnioAnterior = this.model.doc.cuerpo.cc_id_552[i].v;
      this.modelForm.CostoFiscal = this.dutilidades.obtenerFormatoMoneda(this.model.doc.cuerpo.cc_id_553[i].v);
      this.modelForm.RetencionDivididoImpuestoExterior = this.model.doc.cuerpo.cc_id_554[i].v;
      this.modelForm.utilidad = this.model.doc.cuerpo.cc_id_555[i].v;
      this.modelForm.ResultadoArt73Masmejoras = this.model.doc.cuerpo.cc_id_556[i].v;
      this.modelForm.AvaluoCatastralMasMejoras = this.model.doc.cuerpo.cc_id_557[i].v;
      this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras = this.model.doc.cuerpo.cc_id_558[i].v;
      this.modelForm.ValorDeCompraMasMejoras = this.model.doc.cuerpo.cc_id_559[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida() {
    let indexModel = this.model.doc.cuerpo.cc_id_535.length;
    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_2256_5','VAR_2075'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      
      const grupos=[
        ['VAR_2256_5'],
        ['VAR_2075']
      ];

      if (resData) {
        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {


            this.modelForm.id = indexModel;
            this.modelForm.informante = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen = '0' //this.data.sugerida[i].origen;
            this.modelForm.Aniodecompra="2020";
            this.modelForm.TipodeActivo="4";
            if(this.lstTipoActivos.find(elemento => elemento.valor.toString() == this.modelForm.TipodeActivo))
              this.modelForm.nombreTipoActivo = this.lstTipoActivos.find(elemento => elemento.valor.toString() == this.modelForm.TipodeActivo).nombre;

            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }
          }

        }
      }

    }

    this.operacionCs539();
  }
  
  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.ValorVenta=String(valor);
      break;
      case 1:
        itemModelForm.RetencionDivididoImpuestoExterior=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }

  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_535[this.modelForm.id].v = this.modelForm.informante;
    this.model.doc.cuerpo.cc_id_546[this.modelForm.id].v = this.modelForm.Ubicacion;
    this.model.doc.cuerpo.cc_id_537[this.modelForm.id].v = this.modelForm.TipodeActivo;
    this.model.doc.cuerpo.cc_id_536[this.modelForm.id].v = this.modelForm.origen;
    this.model.doc.cuerpo.cc_id_547[this.modelForm.id].v = this.modelForm.Aniodecompra;
    this.model.doc.cuerpo.cc_id_548[this.modelForm.id].v = this.modelForm.ValordeCompra;
    this.model.doc.cuerpo.cc_id_549[this.modelForm.id].v = this.modelForm.AnioAnteriorAplicoReajusteArt73ET;
    this.model.doc.cuerpo.cc_id_550[this.modelForm.id].v = this.modelForm.ValorDeclaradoAnioAnterior;
    this.model.doc.cuerpo.cc_id_538[this.modelForm.id].v = this.modelForm.ValorVenta;
    this.model.doc.cuerpo.cc_id_551[this.modelForm.id].v = this.modelForm.Mejoras;
    this.model.doc.cuerpo.cc_id_552[this.modelForm.id].v = this.modelForm.AvaluoCatastralAnioAnterior;
    this.model.doc.cuerpo.cc_id_553[this.modelForm.id].v = this.modelForm.CostoFiscal;
    this.model.doc.cuerpo.cc_id_554[this.modelForm.id].v = this.modelForm.RetencionDivididoImpuestoExterior;
    this.model.doc.cuerpo.cc_id_555[this.modelForm.id].v = this.modelForm.utilidad;
    this.model.doc.cuerpo.cc_id_556[this.modelForm.id].v = this.modelForm.ResultadoArt73Masmejoras;
    this.model.doc.cuerpo.cc_id_557[this.modelForm.id].v = this.modelForm.AvaluoCatastralMasMejoras;
    this.model.doc.cuerpo.cc_id_558[this.modelForm.id].v = this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras;
    this.model.doc.cuerpo.cc_id_559[this.modelForm.id].v = this.modelForm.ValorDeCompraMasMejoras;

  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_535.push({ it: i, v: this.modelForm.informante });
    this.model.doc.cuerpo.cc_id_546.push({ it: i, v: this.modelForm.Ubicacion });
    this.model.doc.cuerpo.cc_id_537.push({ it: i, v: this.modelForm.TipodeActivo });
    this.model.doc.cuerpo.cc_id_536.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_547.push({ it: i, v: this.modelForm.Aniodecompra });
    this.model.doc.cuerpo.cc_id_548.push({ it: i, v: this.modelForm.ValordeCompra });
    this.model.doc.cuerpo.cc_id_549.push({ it: i, v: this.modelForm.AnioAnteriorAplicoReajusteArt73ET });
    this.model.doc.cuerpo.cc_id_550.push({ it: i, v: this.modelForm.ValorDeclaradoAnioAnterior });
    this.model.doc.cuerpo.cc_id_538.push({ it: i, v: this.modelForm.ValorVenta });
    this.model.doc.cuerpo.cc_id_551.push({ it: i, v: this.modelForm.Mejoras });
    this.model.doc.cuerpo.cc_id_552.push({ it: i, v: this.modelForm.AvaluoCatastralAnioAnterior });
    this.model.doc.cuerpo.cc_id_553.push({ it: i, v: this.modelForm.CostoFiscal });
    this.model.doc.cuerpo.cc_id_554.push({ it: i, v: this.modelForm.RetencionDivididoImpuestoExterior });
    this.model.doc.cuerpo.cc_id_555.push({ it: i, v: this.modelForm.utilidad });
    this.model.doc.cuerpo.cc_id_556.push({ it: i, v: this.modelForm.ResultadoArt73Masmejoras });
    this.model.doc.cuerpo.cc_id_557.push({ it: i, v: this.modelForm.AvaluoCatastralMasMejoras });
    this.model.doc.cuerpo.cc_id_558.push({ it: i, v: this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras });
    this.model.doc.cuerpo.cc_id_559.push({ it: i, v: this.modelForm.ValorDeCompraMasMejoras });

  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_546.splice(index, 1);
    this.model.doc.cuerpo.cc_id_537.splice(index, 1);
    this.model.doc.cuerpo.cc_id_536.splice(index, 1);
    this.model.doc.cuerpo.cc_id_547.splice(index, 1);
    this.model.doc.cuerpo.cc_id_548.splice(index, 1);
    this.model.doc.cuerpo.cc_id_549.splice(index, 1);
    this.model.doc.cuerpo.cc_id_550.splice(index, 1);
    this.model.doc.cuerpo.cc_id_538.splice(index, 1);
    this.model.doc.cuerpo.cc_id_551.splice(index, 1);
    this.model.doc.cuerpo.cc_id_552.splice(index, 1);
    this.model.doc.cuerpo.cc_id_553.splice(index, 1);
    this.model.doc.cuerpo.cc_id_554.splice(index, 1);
    this.model.doc.cuerpo.cc_id_555.splice(index, 1);
    this.model.doc.cuerpo.cc_id_556.splice(index, 1);
    this.model.doc.cuerpo.cc_id_557.splice(index, 1);
    this.model.doc.cuerpo.cc_id_558.splice(index, 1);
    this.model.doc.cuerpo.cc_id_559.splice(index, 1);





    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_535.length; i++) {
      this.model.doc.cuerpo.cc_id_546[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_537[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_536[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_547[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_548[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_549[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_550[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_538[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_551[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_552[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_553[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_554[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_555[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_556[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_557[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_558[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_559[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {


    return (

      this.modelForm.Ubicacion == undefined || this.modelForm.Ubicacion == null ||
      this.modelForm.TipodeActivo == undefined || this.modelForm.TipodeActivo == null ||
      this.modelForm.origen == undefined || this.modelForm.origen == null ||
      this.modelForm.Aniodecompra == undefined || this.modelForm.Aniodecompra == null ||
      this.modelForm.ValordeCompra == undefined || this.modelForm.ValordeCompra == null ||
      this.modelForm.AnioAnteriorAplicoReajusteArt73ET == undefined || this.modelForm.AnioAnteriorAplicoReajusteArt73ET == null ||
      this.modelForm.ValorDeclaradoAnioAnterior == undefined || this.modelForm.ValorDeclaradoAnioAnterior == null ||
      this.modelForm.ValorVenta == undefined || this.modelForm.ValorVenta == null ||
      this.modelForm.Mejoras == undefined || this.modelForm.Mejoras == null ||
      this.modelForm.AvaluoCatastralAnioAnterior == undefined || this.modelForm.AvaluoCatastralAnioAnterior == null ||
      this.modelForm.CostoFiscal == undefined || this.modelForm.CostoFiscal == null ||
      this.modelForm.RetencionDivididoImpuestoExterior == undefined || this.modelForm.RetencionDivididoImpuestoExterior == null ||
      this.modelForm.ResultadoArt73Masmejoras == undefined || this.modelForm.ResultadoArt73Masmejoras == null ||
      this.modelForm.AvaluoCatastralMasMejoras == undefined || this.modelForm.AvaluoCatastralMasMejoras == null ||
      this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras == undefined || this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras == null ||
      this.modelForm.ValorDeCompraMasMejoras == undefined || this.modelForm.ValorDeCompraMasMejoras == null
    );
  }

  public redondearFormData() {
    // console.log('this.modelForm antes de redondear:' + JSON.stringify(this.modelForm));
    // this.modelForm.Ubicacion = this.dutilidades.redondearValorMoneda(this.modelForm.Ubicacion, true);
    // this.modelForm.TipodeActivo = this.dutilidades.redondearValorMoneda(this.modelForm.TipodeActivo, true);
    // this.modelForm.Aniodecompra = this.dutilidades.redondearValorMoneda(this.modelForm.Aniodecompra, true);
    this.modelForm.ValordeCompra = this.dutilidades.redondearValorMoneda(this.modelForm.ValordeCompra, true);
    // this.modelForm.AnioAnteriorAplicoReajusteArt73ET = this.dutilidades.redondearValorMoneda(this.modelForm.AnioAnteriorAplicoReajusteArt73ET, true);
    this.modelForm.ValorDeclaradoAnioAnterior = this.dutilidades.redondearValorMoneda(this.modelForm.ValorDeclaradoAnioAnterior, true);
    this.modelForm.ValorVenta = this.dutilidades.redondearValorMoneda(this.modelForm.ValorVenta, true);
    this.modelForm.Mejoras = this.dutilidades.redondearValorMoneda(this.modelForm.Mejoras, true);
    this.modelForm.AvaluoCatastralAnioAnterior = this.dutilidades.redondearValorMoneda(this.modelForm.AvaluoCatastralAnioAnterior, true);
    // this.modelForm.CostoFiscal = this.dutilidades.redondearValorMoneda(this.modelForm.CostoFiscal, true);
    this.modelForm.RetencionDivididoImpuestoExterior = this.dutilidades.redondearValorMoneda(this.modelForm.RetencionDivididoImpuestoExterior, true);
    this.modelForm.utilidad = this.dutilidades.redondearValorMoneda(this.modelForm.utilidad, true);
    this.modelForm.ResultadoArt73Masmejoras = this.dutilidades.redondearValorMoneda(this.modelForm.ResultadoArt73Masmejoras, true);
    this.modelForm.AvaluoCatastralMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.AvaluoCatastralMasMejoras, true);
    this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras, true);
    this.modelForm.ValorDeCompraMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.ValorDeCompraMasMejoras, true);
    // console.log('this.modelForm antes de redondear:' + JSON.stringify(this.modelForm));

  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();


    if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.modelForm.TipodeActivo, '1')) {
      this.modelForm.AvaluoCatastralAnioAnterior = '0';
      this.modelForm.Mejoras = '0';
    }


    //casillas ocultas vvvv
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.TipodeActivo, '0')) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.modelForm.AnioAnteriorAplicoReajusteArt73ET, '1')) {
        let registroArt73;
        let resultado;
        switch (this.modelForm.TipodeActivo) {
          case '1':
            //inmuebles
            registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.Aniodecompra == ite.anio && ite.anioGravable == "2023");
            resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.ValordeCompra, registroArt73.bienes.toString(), false);
            break;
          case '2':
            //acciones o aportes
            registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.Aniodecompra == ite.anio && ite.anioGravable == "2023");
            resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.ValordeCompra, registroArt73.acciones.toString(), false);

            break;
          case '3':
            //acciones bolsa de Colombia
            registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.Aniodecompra == ite.anio && ite.anioGravable == "2023");
            resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.ValordeCompra, registroArt73.acciones.toString(), false);
            break;
          case '4':
            //otros
            registroArt73 = '0';
            resultado = '0'

            break;

          default:
            break;
        }

        this.modelForm.ResultadoArt73Masmejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, this.modelForm.Mejoras, false);;
      }
    }
    this.modelForm.AvaluoCatastralMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.AvaluoCatastralAnioAnterior, this.modelForm.Mejoras, false);
    this.modelForm.ValorDeclaradoAnioAnteriorMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.ValorDeclaradoAnioAnterior, this.modelForm.Mejoras, false);
    this.modelForm.ValorDeCompraMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.ValordeCompra, this.modelForm.Mejoras, false);


    this.modelForm.utilidad = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.modelForm.ValorVenta, this.modelForm.CostoFiscal, true);
    //casillas ocultas ^^^^

    // if (this.modelForm.adquisicion == "1") {
    //   this.modelForm.valAjustadoArt70 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valDeclaradoAnioAnterior.toString(), "1.1240", true);
    //   this.modelForm.valAjustadoArt70 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt70.toString(), true);
    //   if (this.modelForm.aplicoArt73 == "1") {
    //     let registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.anioCompra == ite.anio && ite.anioGravable == "2023");
    //     let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valCompra.toString(), registroArt73.bienes.toString(), false);
    //     this.modelForm.valAjustadoArt73 = resultado;
    //     this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(), true);

    //   } else {
    //     this.modelForm.valAjustadoArt73 = "0";
    //   }
    //   this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(), true);
    // } else {
    //   this.modelForm.valAjustadoArt70 = "0";
    //   this.modelForm.valAjustadoArt73 = "0";
    // }


    // switch (Number(this.modelForm.art)) {
    //   case 1:
    //     if (this.modelForm.adquisicion == "1")
    //       this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valCatastral.toString(), this.modelForm.mejoras.toString());
    //     else
    //       this.modelForm.valDeclarar = this.modelForm.valCompra.toString();

    //     break;
    //   case 2:
    //     if (this.modelForm.adquisicion == "1") {
    //       this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valCompra.toString(), this.modelForm.mejoras.toString());
    //     } else {
    //       this.modelForm.valDeclarar = this.modelForm.valCompra.toString();

    //     }
    //     break;
    //   case 3:
    //     this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valDeclaradoAnioAnterior.toString(), this.modelForm.mejoras.toString());
    //     break;
    //   case 4:
    //     this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valAjustadoArt70.toString(), this.modelForm.mejoras.toString());
    //     break;
    //   case 5:
    //     this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valAjustadoArt73.toString(), this.modelForm.mejoras.toString());
    //     break;
    //   default:
    //     this.modelForm.valDeclarar = "0";
    // }
    // this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(), true);
    this.reloadSelArticulos(conservarArt);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla == this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        // const existeValor = this.model.doc.cuerpo.cc_id_535.some(item => item.v === this.modelForm.informante);

        // if (this.modelForm.origen == "2" || this.modelForm.origen == "1" || (existeValor && this.modelForm.origen == "0")) { //editando contribuyente o editando sugerida
        //   this.modelForm.origen = this.modelForm.origen == "0" && this.modelForm.origen == "0" ? "1" : this.modelForm.origen;
        //   this.editModeloDesdeForm();
        // } else if (this.modelForm.origen == "0") { //editando sugerida
        //   this.modelForm.origen = "1";
        //   this.modelForm.id = this.model.doc.cuerpo.cc_id_535.length;
        //   this.addToModeloDesdeForm();
        // }

        if (this.modelForm.origen == "0") {
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
        // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion) - 1].nombre;
        // this.editModeloDesdeForm();
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_535.length;
        this.modelForm.origen = "2";
        this.modelForm.informante = "Contribuyente";
        this.modelForm.nombreTipoActivo = this.lstTipoActivos.find(elemento => elemento.valor.toString() == this.modelForm.TipodeActivo).nombre;

        // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion) - 1].nombre;
        this.dataSourceBody.push(this.modelForm);
        // this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs539();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs539();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.calcularValoresForm();
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      // this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  /*   public validateRbQuestions(val: string) {
      this.modelForm.aplicoArt73 = val;
      this.calcularValoresForm();
    } */

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /*  public validateStepHabilitado(indexS:number):boolean{
     let habilitado = true;
     return habilitado;
   } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs539();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar() {
    this.model.doc.cuerpo.cc_id_535 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs539();

    


    console.log(this.model.doc.cuerpo.cs_id_691)
    this.saveModel.emit(true);
    //if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    //} 
  }
  public borrarTabla() {
    this.dataSourceBody = [];
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-venta-activos-fijos-modal/ingresos-venta-activos-fijos-modal.component.ts